import BpmnPropertiesPanel from "./PropertiesPanel.vue";

BpmnPropertiesPanel.install = function(Vue) {
  Vue.component(BpmnPropertiesPanel.name, BpmnPropertiesPanel);
};

export default BpmnPropertiesPanel;
